var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLineUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Arrow/Double",
    transform: "translate(-3.000000, -5.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29411765,1.70974346e-13 L6.58823529,3.29411765 L5.81411765,4.06823529 L3.84313725,2.1027451 L3.84313725,9.88235294 L2.74509804,9.88235294 L2.74509804,2.1027451 L0.774117647,4.06823529 L5.90860694e-13,3.29411765 L3.29411765,1.70974346e-13 Z M11.254902,2.22044605e-15 L11.254902,7.77960784 L13.2258824,5.81411765 L14,6.58823529 L10.7058824,9.88235294 L7.41176471,6.58823529 L8.18588235,5.81411765 L10.1568627,7.77960784 L10.1568627,2.22044605e-15 L11.254902,2.22044605e-15 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineUpDown);
export default __webpack_public_path__ + "static/media/arrow-line-up-down.49f5b9e0a64226f8dc98c96b364a74cf.svg";
export { ForwardRef as ReactComponent };